import { memo } from 'react';
import { GalleryCard } from '../GalleryCard';
import type { GalleryProfileCard } from '../../../types/gallery';
import './GridLayout.css';

// ==========================================
// TYPES
// ==========================================

interface GridLayoutProps {
  profiles: GalleryProfileCard[];
  onProfileClick: (profileId: string, position: number) => void;
  onSwipeStart: (profileId: string) => void;
  selectedProfileId?: string;
  cardVariant?: 'icon' | 'compact';
  columns?: 'auto' | 2 | 3 | 4 | 5 | 6;
  gap?: 'sm' | 'md' | 'lg';
  className?: string;
}

// ==========================================
// COMPONENT
// ==========================================

function GridLayoutComponent({
  profiles,
  onProfileClick,
  onSwipeStart,
  selectedProfileId,
  cardVariant = 'icon',
  columns = 'auto',
  gap = 'md',
  className = '',
}: GridLayoutProps) {
  if (profiles.length === 0) {
    return null;
  }

  const gridClass = [
    'gallery-grid',
    `gallery-grid--${cardVariant}`,
    columns !== 'auto' ? `gallery-grid--cols-${columns}` : '',
    `gallery-grid--gap-${gap}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={gridClass}>
      {profiles.map((profile, index) => (
        <GalleryCard
          key={profile.profileId}
          profile={profile}
          variant={cardVariant}
          onClick={() => onProfileClick(profile.profileId, index)}
          onSwipeStart={() => onSwipeStart(profile.profileId)}
          isSelected={profile.profileId === selectedProfileId}
        />
      ))}
    </div>
  );
}

export const GridLayout = memo(GridLayoutComponent);
